import {
  STPD_SET_VIEW,
  STPD_SET_FILTERS,
  STPD_SET_DATA,
  STPD_SET_SIDEBAR,
  STPD_SET_LOADING,
  STPD_SET_FILTERS_DATA,
  STPD_SET_FILTERS_LOADING,
  STPD_SET_MODAL_LIST,
  STPD_SET_CONVERSION_BY_GROUPS,
  STPD_SET_CONVERSION_BY_CONVERTIBLE,
  STPD_SET_CONVERSION_MODE,
  STPD_SET_FILTERS_SUMMARY,
} from './enums/DashboardTypes';

export const initialState = {
  sitesOnline: 10,
  sitesDeployed: 5,
  filters: {
    loading: false,
    data: {
      divisions: [],
      site_groups: [],
      sites: [],
    },
    selected: {},
    summary: [
      {
        label: 'Selected Date',
        showValue: '',
        iconCls: 'cil-calendar',
      },
      {
        label: 'Previous Date',
        showValue: '',
        iconCls: 'cil-calendar',
      },
      {
        label: 'Divisions',
        iconCls: 'cil-sitemap',
        cssClass: 'w-75',
        showValue: 'All Divisions',
      },
    ],
  },
  data: {
    selected_date: {},
    totals: {
      current: {},
      previous: {},
    },
    stores: [],
    day_parts: [],
    line_chart: [],
    daily_averages: [],
  },
  sidebar: false,
  loading: false,
  modalList: false,
  conversionByGroups: false,
  conversionByConvertibleEntrances: true,
};

const DashBoardDSTPDReducer = (state = initialState, action) => {
  switch (action.type) {
    case STPD_SET_VIEW:
      return { ...state, filters: { ...state.filters, view: action.data } };
    case STPD_SET_DATA:
      return { ...state, data: action.data };

    case STPD_SET_FILTERS:
      return {
        ...state,
        filters: { ...state.filters, selected: action.data },
      };
    case STPD_SET_FILTERS_DATA:
      return { ...state, filters: { ...state.filters, data: action.data } };
    case STPD_SET_FILTERS_LOADING:
      return { ...state, filters: { ...state.filters, loading: action.value } };
    case STPD_SET_FILTERS_SUMMARY:
      return {
        ...state,
        filters: { ...state.filters, summary: action.data },
      };
    case STPD_SET_SIDEBAR:
      return { ...state, sidebar: !state.sidebar };
    case STPD_SET_LOADING:
      return { ...state, loading: action.value };
    case STPD_SET_MODAL_LIST:
      return { ...state, modalList: !state.modalList };
    case STPD_SET_CONVERSION_BY_GROUPS:
      return { ...state, conversionByGroups: !state.conversionByGroups };
    case STPD_SET_CONVERSION_BY_CONVERTIBLE:
      return {
        ...state,
        conversionByConvertibleEntrances:
          !state.conversionByConvertibleEntrances,
      };
    case STPD_SET_CONVERSION_MODE: {
      const modes = {
        entrances: {
          conversionByGroups: false,
          conversionByConvertibleEntrances: false,
        },
        convertible: {
          conversionByGroups: false,
          conversionByConvertibleEntrances: true,
        },
        groups: {
          conversionByGroups: true,
          conversionByConvertibleEntrances: false,
        },
      };
      const next = modes[action.mode];
      if (!next) return state;
      return { ...state, ...next };
    }
    default:
      return state;
  }
};
export default DashBoardDSTPDReducer;
